import { render, staticRenderFns } from "./Testy.vue?vue&type=template&id=87f6fdcc&scoped=true&"
import script from "./Testy.vue?vue&type=script&lang=js&"
export * from "./Testy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f6fdcc",
  null
  
)

export default component.exports